import PaymentGuide from "./PaymentGuide";

export default PaymentGuide;
